import React from 'react';
import { defMenu } from '../../../../constants';
import PresetIcon from '../../../../assets/menu/preset.svg?react';
import StoreIcon from '../../../../assets/menu/store.svg?react';
import RecentIcon from '../../../../assets/menu/recent.svg?react';
import HotIcon from '../../../../assets/menu/hot.svg?react';
import LightShadow from '../../LightShadow';
import { setModelsModalState, useModelsModalState } from '../../../../store/state';
import { formatMenuState } from './utils';
import ImgIcon from './ImgIcon';
import { Icon } from '@shakkerai/components';
import cs from 'classnames';

const choosedColor = '#009DFF';
const unChoosedColor = '#2D2D2D';

const SideBar = React.memo(({ menus, setMenus, JumpLink, modelType }) => {
  const isInGlobalSearching = useModelsModalState('isInGlobalSearching');

  const getMenuIcon = (item, level) => {
    if (level !== 0) {
      return null;
    }
    switch (true) {
      case item.id === defMenu.presetModelId:
        return <PresetIcon fill={item.choosed ? choosedColor : unChoosedColor} />;
      case item.id === defMenu.collectModelId:
        return <StoreIcon fill={item.choosed ? choosedColor : unChoosedColor} />;
      case item.id === defMenu.historyModelId:
        return <RecentIcon fill={item.choosed ? choosedColor : unChoosedColor} stroke="#fff" />;
      case item.id === defMenu.hotRecommendId:
        return <HotIcon fill={item.choosed ? choosedColor : unChoosedColor} />;
      case item.children?.length > 0:
        return (
          <Icon
            fontSize={14}
            className={cs('icon-topbar_arrow_down ml-[2px]', item.open ? '' : '-rotate-90')}
            color={item.choosed ? '#009DFF' : ''}
          />
        );
      default:
        return <div className="w-4 h-4" />;
    }
  };

  const choose = (e, item) => {
    if (isInGlobalSearching) return; // 搜索模式下不让点击菜单
    // 这是因为选中文案的时候，如果是展开状态就不让关闭了，除非点击了箭头
    const forceOpenId = e.target.getAttribute('data-id');
    // 更新选中状态
    let newMenu = formatMenuState(menus, item, forceOpenId);

    setMenus(newMenu);
    setModelsModalState({
      collectState: {},
      keyword: '',
      isInGlobalSearchState: false,
      globalSearchDataCount: 0,
      [`${modelType}CurrentMenuId`]: item.id,
    });
  };
  const getMenusTree = (list) => {
    return (
      <div className="flex flex-col w-full">
        {list.map((item) => (
          <div key={item.id} className="flex-1">
            <div
              onClick={(e) => choose(e, item)}
              style={{ paddingLeft: item.level === 1 ? '34px' : '' }}
              className={cs(
                'flex w-full px-2 justify-start items-center h-9 rounded text-[#2D2D2D] text-[13px]',
                isInGlobalSearching ? 'cursor-not-allowed' : 'cursor-pointer hover:bg-[#F4F6F8]',
              )}
            >
              {item.level === 0 && getMenuIcon(item, 0)}
              <span
                data-id={item.id}
                className="ml-2 select-none relative top-[1px]"
                style={{ color: item.choosed ? choosedColor : unChoosedColor }}
              >
                {item.tagLabel}
              </span>
            </div>
            {item.children && item.open ? getMenusTree(item.children) : null}
          </div>
        ))}
      </div>
    );
  };
  if (menus?.length) {
    return (
      <div className="relative w-full h-full p-2">
        <div
          className="bg-[#fff] items-start w-full flex rounded overflow-auto"
          style={{ height: JumpLink ? 'calc(100% - 42px)' : '100%' }}
        >
          {getMenusTree(menus, 0)}
        </div>
        <div style={{ height: JumpLink ? '42px' : '0' }} className="w-full flex justify-center items-center">
          {JumpLink && <JumpLink />}
        </div>
      </div>
    );
  } else {
    return (
      <div className="w-full h-full">
        <LightShadow />
      </div>
    );
  }
});

export default SideBar;
